import Vue from 'vue'
import { Button, Card, Form, FormItem, Input, InputNumber, Message, MessageBox, Dropdown, DropdownMenu, DropdownItem,} from 'element-ui'

Vue.use(Card)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.prototype.$message = Message;
Vue.prototype.$messageBox = MessageBox;
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)




// WEBPACK FOOTER //
// ./src/plugins/element.js